import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { take } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { RxLet } from '@rx-angular/template/let';
import { Observable } from 'rxjs';
import { ContentComponent } from '@rx-lib/ui';
import { ActivatedRoute } from '@angular/router';
import { Page } from '@rx-lib/ui';
import { RouteMapEntry } from '@rx-lib/models';

@Component({
  selector: 'lib-about',
  standalone: true,
  imports: [CommonModule, RxLet, ContentComponent],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutComponent {

  private currentRoute$: Observable<RouteMapEntry> = inject(ActivatedRoute).snapshot.data['currentRoute'];

  public page$: Observable<Page> = this.currentRoute$.pipe(
    // tap((currentRoute) => console.log('AboutComponent currentRoute', currentRoute)),
    map((currentRoute) => currentRoute.page),
    // tap((page) => console.log('AboutComponent page', page)),
    take(1)
  );
}
